import styled from 'styled-components';

import Dialog from '@mui/material/Dialog';

const StyledModal = styled(Dialog)`
  .MuiPaper-root {
    padding: 24px;
    border-radius: 8px;
    border: 0px solid ${({ theme }) => theme.palette.grey[200]};
    background: ${({ theme }) => theme.palette.common.white};
    box-shadow: ${({ theme }) => theme.shadows.card};
  }
`;

export const Modal = styled(StyledModal)`
  .MuiPaper-root {
    max-width: 660px;
    border-radius: 8px;
  }
`;

export const GreenHeader = styled.h2`
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.15px;
  text-transform: capitalize;
  color: ${({ theme }) => theme.palette.success.main};
  margin: 0;
`;

export const InfoText = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.1px;
  margin: 0;
`;

export const Title = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  font-weight: 400;
  margin-top: 24px;
`;
